import axios from "axios";
import { yiapiRequestGet, yiapiRequestPost } from 'utils/platFormSign'
import { toNumbers } from '@/utils/utils'
import { getPlatform, getEnvHost } from 'lib/tools/getPlatform'

// window.yxlAppToken = window.yxlAppToken ? window.yxlAppToken : "8b35ef3bdb44c95ae2099434ecfd2c15"
// "8b35ef3bdb44c95ae2099434ecfd2c15" 13760631005
// "7380e13519e3e90f89f5cef58f5219a8" test@test.com
const M_HOST = getEnvHost(`${location.protocol}//m.xinli001.com`)
// 用户鲸币
export function getUserCoinInfo () {
  return new Promise((resolve, reject) => {
    yiapiRequestGet(window.$liveApi.yiapi_url + `/v6/yi/get-user-yxl-coin.json`, {
      token: window.yxlAppToken || ''
    })
    .then(res => {
      const resData = res.data
      if (+resData.code === 0) {
        resData.data = toNumbers(resData.data)
        resData.data.withdrawa_coin = toNumbers(resData.data.withdrawa_coin)
        resData.data.consume_coin_info = toNumbers(resData.data.consume_coin_info)
        resolve(res)
      } else {
        reject(res)
      }
    })
    .catch(e => {
      reject(e)
    })
  })
}

// 消费记录
export function getUserCoinReward (page, size, date) {
  return yiapiRequestGet(window.$liveApi.yiapi_url + `/v6/yi/get-user-coin-reward.json`, {
    page,
    size,
    date,
    token: window.yxlAppToken || ''
  })
}

// 充值记录
export function getUserCoinOrder (page, size, date) {
  return yiapiRequestGet(window.$liveApi.yiapi_url + `/v6/yi/get-user-coin-order.json`, {
    page,
    size,
    date,
    token: window.yxlAppToken || ''
  })
}

// 收入记录
export function getUserCoinIncome (page, size) {
  return yiapiRequestGet(window.$liveApi.yiapi_url + `/v6/yi/get-user-coin-income.json`, {
    page,
    size,
    token: window.yxlAppToken || ''
  })
}

// 产品列表
export function getCoinProductList () {
  return yiapiRequestGet(window.$liveApi.yiapi_url + `/v6/yi/get-coin-product-list.json`, {
    token: window.yxlAppToken || ''
  })
}

// 鲸币支付
export function zhifu (object_id, payway) {
  const { isAndroid , isiOS } = getPlatform()
  let _platform = ''
  if (isAndroid) {
    _platform = 'android'
  } else if (isiOS) {
    _platform = 'ios'
  }
  return yiapiRequestPost(window.$liveApi.yiapi_url + '/v6/yi/yxl-coin-zhifu.json', {
    object_id,
    payway,
    _platform,
    token: window.yxlAppToken || '',
  })
}

// 直播收入 - 提现列表
export function getWithdrawList (page, size, status) {
  return axios.get(M_HOST + '/live/withdraw/list', {
    params: {
      page,
      size,
      token: window.yxlAppToken || '',
      status,
      is_new: 1
    }
  })
}

// 直播收入 -  提现页面
export function getWithdrawInfo () {
  return axios.get(M_HOST + '/live/withdraw/info', {
    params: {
      token: window.yxlAppToken || '',
    }
  })
}
